import { useState } from 'react';
import { ConnectWalletModal } from '../components/common';

export const useConnectWallet = () => {
  const [showConnectWalletModal, setShowConnectWalletModal] = useState(false);
  const [sellectedChain, setSellectedChain] = useState(null);

  const connectWallet = (selectedChain = null) => {
    setShowConnectWalletModal(true);
    if (typeof(selectedChain) === "string") setSellectedChain(selectedChain);
  };

  const connectWalletModal = () => (
    <ConnectWalletModal
      show={showConnectWalletModal}
      onHide={() => setShowConnectWalletModal(false)}
      selectedChain={sellectedChain}
    />
  );

  return { connectWallet, connectWalletModal };
};
